/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/auth-member-search';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
        inlineTableView: true,
        expandedTableView: true,
    },
    dimensions: {
        maxHeight: 240,
    },
    columnWidth: {
        firstName: 90,
        lastName: 90,
        dob: 80,
        memberId: 100,
        mfiNumber: 100,
        relationship: 100,
        phoneNumber: 100,
        email: 150,
        stateAndZip: 90,
        carrier: 100,
        group: 100,
        eligibilityStatus: 100,
        
        // special columns
        _groupActions: 70, // group actions column
    },
    actionIcons: {
        initiateCall: 'phone',
    },
};
